var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"errorIndex"},[_c('Header'),_vm._v(" "),_c('el-main',{staticClass:"flex_justify_center"},[_c('p',{staticClass:"font_24_bold color_black"},[_vm._v(_vm._s(_vm.$t('global.error'))),_c('br'),_vm._v(" "+_vm._s(_vm.$t('global.trtAgain')))]),_vm._v(" "),_c('img',{attrs:{"src":require("../assets/Error.svg")}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c7f8e3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/error.vue
// module id = null
// module chunks = 